import React from 'react';

export default function AdvancedFilters({ filters, onChange }) {
  const handleCityChange = e => onChange({ ...filters, city: e.target.value });
  const handleAreaChange = e => onChange({ ...filters, area: e.target.value });

  return (
    <div style={{ margin: '20px 0' }}>
      <label style={{ marginRight: 10 }}>
        City / المدينة:
        <input
          type="text"
          value={filters.city || ''}
          onChange={handleCityChange}
          placeholder="Kuwait City / مدينة الكويت"
          style={{ marginLeft: 8, padding: 4 }}
        />
      </label>
      <label>
        Area / المنطقة:
        <input
          type="text"
          value={filters.area || ''}
          onChange={handleAreaChange}
          placeholder="Salmiya / السالمية"
          style={{ marginLeft: 8, padding: 4 }}
        />
      </label>
    </div>
  );
}
